export enum PromptResult {
  NO = 'NO',
  YES = 'YES',
  CANCEL = 'CANCEL',
}
